// Get item SKUs in cart that match any SKUs in restrictedItems
import { CartFragment } from '../../graphql/magento'
import { Maybe } from '../../utils/types'
import { ShippingCountry } from './hooks/useShippingCountries'
import { RestrictedItem } from './types'

export type SanityRestrictedSkusFilters =
  | {
      country: string
      type?: 'region'
      region: string
    }
  | {
      country: string
      type: 'all-regions'
    }

export const filterSanityRestrictedSkus =
  (shippingCountries: ShippingCountry[]) =>
  (filters: SanityRestrictedSkusFilters): Maybe<string>[] =>
    shippingCountries
      .find((shippingCountry) => shippingCountry.country === filters.country)
      ?.shippingRegions?.find((shippingRegion) =>
        filters.type === 'all-regions'
          ? shippingRegion?.isProductsRestrictedForAllRegions
          : shippingRegion?.region?.split('-')[1] === filters.region,
      )
      ?.restrictedProducts?.map((product) => product?.sku) ?? []

export const extractCartRestrictedItems = ({
  customerCart,
  restrictedSkus,
}: {
  customerCart: CartFragment
  restrictedSkus: Maybe<string>[]
}): RestrictedItem[] =>
  (customerCart.items || []).reduce((acc: RestrictedItem[], item) => {
    const { id, product } = item || {}
    const { name, sku } = product || {}

    if (id && restrictedSkus?.includes(sku)) {
      acc.push({ id, name: name || sku || id, sku: sku || '' })
    }
    return acc
  }, [])
